import React, { useState, useEffect } from "react";
import "./Microsoft365Pricing.css";
import { Button, Modal, OverlayTrigger, Tooltip, Card } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import Axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { CurrencyPound, CurrencyEuro } from "react-bootstrap-icons";
import { trim } from "lodash";
import { API_PRICETOOL_ROUTE } from "./Constants";
export default function Microsoft365Pricing(props) {
    var apiUrl = API_PRICETOOL_ROUTE;
    ////var apiUrl = "https://localhost:44318/pricingtool"
    
 
  // const [selectedPlan, setSelectedPlan] = useState("");
  // const [resellerId, setResellerId] = useState(0);
  // const [displayOnly, setDisplayOnly] = useState(true);
  // const [collapsed, setCollapsed] = useState(true);
  const [clickedPlan, setClickedPlan] = useState("");
  // const [planDetails, setPlanDetails] = useState([]);
  // const [showLoader, setShoeLoader] = useState(true);
    const [show, setShow] = useState(false);
    
  const [qparams, setQparams] = useState(
    new URLSearchParams(window.location.search)
  );
  const resellerId=qparams.get("reseller")
if(resellerId){
    apiUrl = API_PRICETOOL_ROUTE +"?reseller="+resellerId
}
  const handleClose = () => {
    setShow(false);
    setClickedPlan("");
  };
  const handleShow = () => setShow(true);
  const handlePlanSelection = (planName, planId) => {
    setClickedPlan(planName);
    handleShow();
  };
    
    const requestFor500Plus = (currentPlan) => {
        props.handleShow500(currentPlan);
    }; 
 
  const [hoveredPlan, setHoveredPlan] = useState(null);
  const handleMouseEnter = (planName) => {
    setHoveredPlan(planName);
  };

  const handleMouseLeave = () => {
    setHoveredPlan(null);
  };

  const renderTooltip = (props) => (
    <Tooltip id={`tooltip-${props.id}`} {...props}>
      {props.text}
    </Tooltip>
  );
useEffect(() => {
    const iframe = document.getElementById('myIframe');

// Wait for the iframe to fully load
iframe.addEventListener('load', function () {
    if (iframe.contentWindow) {
        iframe.contentWindow.postMessage(props.isBlurred, '*');
    }
});
if (iframe.contentWindow) {
        iframe.contentWindow.postMessage(props.isBlurred, '*');
    }
}, [props.isBlurred]);


  return (
    <>
          <iframe id="myIframe" src={apiUrl} style={{width:'100%',height:'100%'}}></iframe>
    </>
  );
}
